import { handleActions } from '@gef-ui/utils/fsaActions';
import { actionTypes } from '../constants';
export default handleActions({
    [actionTypes.SAVE_DELEGATIONS]: (state, { payload })=>({
            ...state,
            delegation: payload
        })
}, {});
